
export const ACCEPTED_IMAGE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/bmp',
    'image/gif',
    'application/octet-stream',
];